module.exports = __webpack_public_path__ + "static/img/RWA966_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA966_1.png
// module id = Ssrf
// module chunks = 0